import {
  getDoneQuizCategoryList,
  getDoneQuizList,
  getQuizCategoryList,
  getQuizList,
} from "@/services/quizService";
import { QUIZ_QUERY_KEYS } from "@/types";
import { filterParams } from "@/utils/filterParams";
import { useInfiniteQuery } from "@tanstack/react-query";

const LIMIT = 15;

export const useQuizList = (s: string) => {
  const queryKey = [QUIZ_QUERY_KEYS.LIST, s];

  const query = useInfiniteQuery({
    queryKey: queryKey,
    queryFn: ({ pageParam = 1, queryKey: [_, s] }) =>
      getQuizList(
        filterParams({
          page: pageParam,
          isPagination: 1,
          limit: LIMIT,
          orderBy: "id",
          order: "DESC",
          s: s,
        })
      ),
    getNextPageParam: (lastPage: any) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
  });

  return {
    ...query,
  };
};

export const useQuizCategoryList = (id: number, s: string) => {
  const queryKey = [QUIZ_QUERY_KEYS.CATEGORY_LIST, s];

  const query = useInfiniteQuery({
    queryKey: queryKey,
    queryFn: ({ pageParam = 1, queryKey: [_, s] }) =>
      getQuizCategoryList(
        id,
        filterParams({
          page: pageParam,
          isPagination: 1,
          limit: LIMIT,
          orderBy: "id",
          order: "DESC",
          s: s,
        })
      ),
    enabled: !!id,
    getNextPageParam: (lastPage: any) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
  });

  return {
    ...query,
  };
};

export const useDoneQuizList = (s: string) => {
  const queryKey = [QUIZ_QUERY_KEYS.DONE_LIST, s];

  const query = useInfiniteQuery({
    queryKey: queryKey,
    queryFn: ({ pageParam = 1, queryKey: [_, s] }) =>
      getDoneQuizList(
        filterParams({
          page: pageParam,
          isPagination: 1,
          limit: LIMIT,
          orderBy: "id",
          order: "DESC",
          s: s,
        })
      ),
    getNextPageParam: (lastPage: any) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
  });

  return {
    ...query,
  };
};

export const useDoneQuizCategoryList = (id: number, s: string) => {
  const queryKey = [QUIZ_QUERY_KEYS.DONE_CATEGORY_LIST, s];

  const query = useInfiniteQuery({
    queryKey: queryKey,
    queryFn: ({ pageParam = 1, queryKey: [_, s] }) =>
      getDoneQuizCategoryList(
        id,
        filterParams({
          page: pageParam,
          isPagination: 1,
          limit: LIMIT,
          orderBy: "id",
          order: "DESC",
          s: s,
        })
      ),
    enabled: !!id,
    getNextPageParam: (lastPage: any) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
  });

  return {
    ...query,
  };
};
